import { Message } from '@/platform/ui';

const summaryFor = issues => {
    if (issues.length === 0) {
        return {
            variant: 'success',
            title: 'Alles werkt',
            text: 'De controles lopen via het UWV-portaal en niets vraagt om actie.',
        };
    }

    if (issues.some(issue => issue.severity === 'error')) {
        return { variant: 'error', title: 'Actie nodig' };
    }

    if (issues.some(issue => issue.severity === 'warning')) {
        return { variant: 'warning', title: 'Aandacht nodig' };
    }

    return { variant: 'neutral', title: 'Geen actie nodig' };
};

/**
 * What a screen reader hears when the health changes, in one sentence or a few.
 */
export const announcementFor = issues => {
    const { title, text } = summaryFor(issues);

    return [title + '.', text ?? issues.map(issue => issue.message).join(' ')]
        .join(' ')
        .trim();
};

/**
 * One answer to "does it work, and do I need to do anything?", from the issues
 * the overview derived.
 */
const HealthSummary = ({ issues }) => {
    const { variant, title, text } = summaryFor(issues);

    return (
        <Message variant={variant} title={title}>
            {text ?? (
                <ul className='list-disc space-y-1 pl-5'>
                    {issues.map(issue => (
                        <li key={issue.key}>
                            {issue.message} {issue.next_step}
                        </li>
                    ))}
                </ul>
            )}
        </Message>
    );
};

export default HealthSummary;
